import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Segment, Loader} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';

class PartSubstitutes extends Component {
  componentDidMount() {
    const {partCode} = this.props;
    this.props.getPartSubstitutes(partCode);
  }

  componentDidUpdate(prevProps, prevState) {
    const {partCode} = this.props;
    if (partCode !== prevProps.partCode) {
      this.props.getPartSubstitutes(partCode);
    }
  }

  renderItems() {
    const {substitutes} = this.props;

    if (!substitutes.length) {
      return <Segment>No hay repuesto sustituto</Segment>;
    }

    return substitutes.map((part) => (
      <Segment key={part.code}>{part.code}</Segment>
    ));
  }

  renderLoaderOrItems() {
    const {loading} = this.props;

    if (loading) {
      return (
        <Loader active inline='centered'>
          Consultando los items sustitutos del repuesto.
        </Loader>
      );
    }
    return this.renderItems();
  }

  render() {
    return (
      <div>
        <h3>Sustituto:</h3>
        <Segment.Group>{this.renderLoaderOrItems()}</Segment.Group>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.partsMaster.loadingSubstitutes,
    'substitutes': state.partsMaster.substitutes,
  };
};

const {getPartSubstitutes} = Actions;

export default connect(mapStateToProps, {getPartSubstitutes})(PartSubstitutes);
